import React, {createContext, useContext, useEffect, useState} from "react";

import {OAuthContext} from "./OAuthContext";
import FetchHelper from "../components/Utils/helper";
import {FetchErrorProps, UserDataProps, UserProviderProps} from "./type";
import {userDataDefaultValue} from "./const";

export const UserContext = createContext<UserDataProps>({
    ...userDataDefaultValue
});

export const UserProvider: React.FC<UserProviderProps> = ({children}) => {
    const {oauthData} = useContext(OAuthContext);

    const [userData, setUserData] = useState<UserDataProps>({...userDataDefaultValue})
    // const [translations, setTranslations] = useState<{[key: string]: string} | null>(null)
    const [errorUser, setErrorUser] = useState<FetchErrorProps>({ error: false, message: "" })

    const getLists = React.useCallback(() => {
        const helper = new FetchHelper(oauthData?.token);
        helper.getUserData().then(res => setUserData({...res})).catch(error => setErrorUser(prevState => ({...prevState, error: true, message: error.message})))
        // helper.getTranslations("de").then( res => setTranslations(res)).catch( error => setErrorUser(prevState => ({...prevState, error: true, message: error.message})))
    }, [oauthData?.token])

    useEffect(() => {
        if (oauthData.token.accessToken) {
            getLists()
        }
    }, [getLists, oauthData?.token?.accessToken])

    const defaultUserContextValue = { ...userData, errorUser, setErrorUser, setUserData};

    return <UserContext.Provider value={defaultUserContextValue}>
        {children}
    </UserContext.Provider>
}